<div class="content-area">
  <app-loading-component *ngIf="isLoading"></app-loading-component>
  <div class="clr-row" *ngIf="!isLoading && post">
    <div class="clr-col-12 clr-col-md-8 post-wrapper">
      <div class="featured-image-wrapper" [style.backgroundImage]="postImage"></div>
      <h1 class="text-center">{{post.title.rendered}}</h1>
      <div>
        <span class="tag mr-1 py-1 px-2" *ngFor="let category of post.parsedCategories">{{category}}</span>
      </div>
      <div [innerHTML]="post.content.rendered" class="post-content"></div>

      <div>
        <disqus [identifier]="post.title.rendered"></disqus>
      </div>
    </div>
  </div>
</div>